export default __webpack_public_path__ + "static/media/star.7304f295.svg";